import React, { useState, useEffect } from 'react'

const Enquiry = () => {

    const [enquiry, setEnquiry] = useState([]);

  useEffect(() => {
    const fetchEnquiry = async () => {
      try {
        const response = await fetch('https://api.shaktitours.com/get-contact');
        const data = await response.json();

        if (response.ok) {
          setEnquiry(data);
        } else {
          console.error('Failed to fetch enquiries:', data);
        }
      } catch (error) {
        console.error('Error while fetching enquiries:', error);
      }
    };

    fetchEnquiry();
  }, []); 

  return (
    <>
                <section className='banner2-bg'>
                <div className='container text-center'>
                    <p className='subheader-text'>Site Enquiry</p>
                </div>
            </section>

      <section className='my-5'>
        <div className='container'>

          {/* <p className='sec-heading fs-5'>Enquiry Received from Site</p> */}

<div className='table-responsive'>
<table className='w-100'>
    <tr className='bg-dark text-light'>
        <th className='px-3 py-2'>S No</th>
        <th className='px-3 py-2'>Name</th>
        <th className='px-3 py-2'>Mobile</th>
        <th className='px-3 py-2'>Email</th>
        <th className='px-3 py-2'>Message</th>
        </tr>

                      {enquiry.length > 0 ? (
                enquiry.map((enquiries, index) => (
                  <tr key={enquiries.id}>
                    <td className='px-3 py-2'>{index + 1}</td>
                    <td className='px-3 py-2'>{enquiries.name}</td>
                    <td className='px-3 py-2'>{enquiries.mobile}</td>
                    <td className='px-3 py-2'>{enquiries.email}</td>
                    <td className='px-3 py-2'>{enquiries.message}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className='px-3 py-2'>No Enquiry Submission</td></tr>
              )}
</table>
</div>

        </div>
      </section>
    </>
  )
}

export default Enquiry
